import { useRef } from 'react';
import { useIntl } from 'react-intl';

import { CrosshairIcon } from '@dynatrace/strato-icons';

import { allowWhenKeyIsEnter } from './utils.js';
import { KeyboardControls } from '../../../core/components/interactions-overlay/constants.js';
import { INTERACTION_MODE } from '../../../core/components/interactions-overlay/types.js';
import { reduceInteractionMode } from '../../../core/components/interactions-state-helpers/reducers/mode-reducers.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { XYCHART_MESSAGES } from '../../messages/messages.js';
import { useInteractionModeState, useSetState } from '../../store/selectors.js';

export const ExploreButton = (props: { placement: 'menu' | 'auto' }) => {
  const setState = useSetState();
  const exploreButtonRef = useRef<HTMLButtonElement>(null);
  const tabIndex = useA11yToolbarTabIndex(INTERACTION_MODE.Explore);
  const intl = useIntl();
  const interactionMode = useInteractionModeState();

  const isSelected = interactionMode === INTERACTION_MODE.Explore;

  const action = () => {
    setState(reduceInteractionMode(INTERACTION_MODE.Explore));
  };

  return (
    <ChartToolbarRenderer.Control
      ref={exploreButtonRef}
      prefixIcon={<CrosshairIcon />}
      tooltipText={intl.formatMessage(XYCHART_MESSAGES.zoomModeExplore)}
      tooltipKeyShortcut={
        KeyboardControls.KEYBOARD_EXPLORE_MODE_SHORTCUT_ALTERNATIVE
      }
      selected={isSelected}
      onKeyDown={allowWhenKeyIsEnter(action)}
      onClick={action}
      tabIndex={tabIndex}
      placement={props.placement}
    />
  );
};

ExploreButton['displayName'] = 'ExploreButton';
